import { useState } from "react";
import CrudTable from "../components/CrudTable";
import PDFButton from "../components/PDFButton";
import PemexVolumeValidation from "../components/PemexVolumeValidation";
import PemexEventos from "../components/PemexEventos";
import PemexOffshoreWarehouse from "../components/PemexOffshoreWarehouse";

const TABS = [
  { key: "pemex_volumes", label: "Validación de Volúmenes" },
  { key: "pemex_solpeds", label: "Solpeds" },
  { key: "pemex_hes", label: "Aprobaciones HES" },
  { key: "pemex_supports", label: "Soportes" },
  { key: "pemex_species_rescue", label: "Rescate de Especies" },
  { key: "pemex_eventos", label: "Eventos" },
  { key: "pemex_almacenes", label: "Estatus de Almacenes" },
];

const fieldsByColl = {
  pemex_solpeds: [
    { key: "code", label: "# Solped" },
    { key: "requested_by", label: "Solicitado por" },
    { key: "waste_type", label: "Tipo residuo" },
    { key: "volume", label: "Volumen" },
    { key: "observations", label: "Observaciones", type: "textarea", full: true },
    { key: "status", label: "Status", type: "select", options: ["Pendiente", "En proceso", "Cerrado"] },
    { key: "date", label: "Fecha", type: "date" },
  ],
  pemex_hes: [
    { key: "code", label: "# HES" },
    { key: "description", label: "Descripción", type: "textarea", full: true },
    { key: "status", label: "Status", type: "select", options: ["Pendiente", "Aprobado", "Rechazado"] },
    { key: "date", label: "Fecha", type: "date" },
  ],
  pemex_supports: [
    { key: "description", label: "Descripción", type: "textarea", full: true, required: true },
    { key: "requested_by", label: "Solicitado por" },
    { key: "contract", label: "# Contrato" },
    { key: "status", label: "Status", type: "select", options: ["Solicitado", "En proceso", "Cerrado"] },
  ],
  pemex_species_rescue: [
    { key: "species_name", label: "Nombre de la especie", required: true },
    { key: "shipment_date", label: "Fecha envío desde instalación", type: "date" },
    { key: "origin_installation", label: "Instalación de origen" },
    { key: "dock_collection_date", label: "Recolección en muelle", type: "date" },
    { key: "release_destination", label: "Destino para liberación" },
    { key: "transport_responsible", label: "Responsable del traslado" },
    { key: "animal_state", label: "Estado del animal al envío", type: "select", options: ["Vivo y sano", "Vivo con lesiones", "Fallecido"] },
    { key: "observations", label: "Observaciones", type: "textarea", full: true },
  ],
};

export default function PEMEX() {
  const [tab, setTab] = useState("pemex_volumes");
  return (
    <div data-testid="pemex-module">
      <div className="flex items-center justify-between mb-3">
        <h1 className="card-h1" style={{ margin: 0 }}>Soporte PEMEX</h1>
        <PDFButton endpoint="/pdf/module/racs" filename="reporte_pemex.pdf" label="Reporte PDF" />
      </div>
      <div className="tabs-bar">
        {TABS.map((t) => <button key={t.key} className={`tab ${tab === t.key ? "active" : ""}`} onClick={() => setTab(t.key)} data-testid={`px-tab-${t.key}`}>{t.label}</button>)}
      </div>
      {tab === "pemex_volumes" ? (
        <PemexVolumeValidation />
      ) : tab === "pemex_eventos" ? (
        <PemexEventos />
      ) : tab === "pemex_almacenes" ? (
        <PemexOffshoreWarehouse />
      ) : (
        <CrudTable collection={tab} testIdPrefix={tab} fields={fieldsByColl[tab]} />
      )}
    </div>
  );
}
